var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteWord(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon / Text"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon/action/description_24px",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.95 3.33334C22.8333 3.33334 23.6833 3.68334 24.3167 4.31667L32.35 12.3667C32.9833 12.9833 33.3333 13.8333 33.3333 14.7167V33.3333C33.3333 35.1667 31.8333 36.6667 30 36.6667H9.98334C8.15 36.6667 6.66667 35.1667 6.66667 33.3333V6.66667C6.66667 4.83334 8.16667 3.33334 10 3.33334H21.95ZM15 30H25C25.9167 30 26.6667 29.25 26.6667 28.3333C26.6667 27.4167 25.9167 26.6667 25 26.6667H15C14.0833 26.6667 13.3333 27.4167 13.3333 28.3333C13.3333 29.25 14.0833 30 15 30ZM25 23.3333H15C14.0833 23.3333 13.3333 22.5833 13.3333 21.6667C13.3333 20.75 14.0833 20 15 20H25C25.9167 20 26.6667 20.75 26.6667 21.6667C26.6667 22.5833 25.9167 23.3333 25 23.3333ZM21.6667 5.83334V13.3333C21.6667 14.25 22.4167 15 23.3333 15H30.8333L21.6667 5.83334Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteWord);
export default __webpack_public_path__ + "static/media/White-Word.6070c0ab58ff49be7b63d804548e8b46.svg";
export { ForwardRef as ReactComponent };